export default "__VITE_ASSET__nGLnyhOP__"